import apiCommonCategory from "@/api/common-category.ts";
import {post} from "@/utils/request.ts";

export default class apiYjAutoArea extends apiCommonCategory{
    static module : string  = 'yj_auto_area'

    static async index() {
        return post(`/home/yj_auto_area/index`)
    }
}
